export const onEditElementUpdate = (schema: string, key: string, val: any, element: any) => {
    return element;
}